import useLoginHeaderLogic from '@/features/Auth/Login/Hooks/useLoginHeaderLogic.ts'
import useTranslationStore from '@/language/useTranslationStore'
import {
    applyImageFallback,
    DEFAULT_IMAGE_SRC,
} from '@/lib/Images/imageFallbacks.ts'

export function LoginHeader() {
    const { t } = useTranslationStore()
    const { state } = useLoginHeaderLogic()

    return (
        <div className="mb-6 text-center">
            <div className="mb-6 flex flex-col items-center gap-3">
                <h1 className="text-2xl font-bold text-white">
                    {state.companyName}
                </h1>
                {state.hasCustomLogo ? (
                    <img
                        src={state.logoSrc}
                        alt={state.companyName}
                        loading="eager"
                        decoding="sync"
                        fetchPriority="high"
                        onError={(event) =>
                            applyImageFallback(event, DEFAULT_IMAGE_SRC)
                        }
                        className="h-26 w-26 rounded-lg object-cover"
                    />
                ) : null}
            </div>
            <h2 className="text-xl font-bold text-white">
                {t('auth.login.title')}
            </h2>
            <p className="text-secondary-text mt-1 text-sm">
                {t('auth.login.description')}
            </p>
        </div>
    )
}
